import React from 'react';
import logo from "./assets/new-logo.png";
import Footer from "./components/Footer";
import "./App.css";

const PrivacyPolicy = () => {
  return (
    <div style={{ backgroundColor: "black", minHeight: "100vh", paddingBottom: "40px" }}>
      <div className="img-con-header">
        <a href="/home">
          <img
            className="imgLogo"
            style={{ margin: "2px auto 0px auto" }}
            src={logo}
            width="10%"
            alt="logo"
          />
        </a>
      </div>
      <div style={{ color: "white", width: "80%", maxWidth: "1000px", margin: "20px auto" }}>
        <h1 className="font-eagle-bold" style={{ fontSize: '36px', marginBottom: '30px' }}>Privacy Policy</h1>

        <p className="font-semibold">
          At Vibe Stream by GOGOPIX Inc., we respect your privacy and are committed to protecting your personal information.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>1. Information We Collect</h2>
        <p className="font-semibold">
          We collect information you provide directly to us, including:
        </p>
        <ul style={{ color: "white", marginLeft: "20px" }}>
          <li className="font-semibold">Email address</li>
          <li className="font-semibold">Phone number (if provided)</li>
          <li className="font-semibold">Payment information (processed securely through Stripe)</li>
          <li className="font-semibold">Usage data and viewing preferences</li>
        </ul>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>2. How We Use Your Information</h2>
        <p className="font-semibold">
          We use the information we collect to:
        </p>
        <ul style={{ color: "white", marginLeft: "20px" }}>
          <li className="font-semibold">Provide and improve our streaming service</li>
          <li className="font-semibold">Process subscription payments</li>
          <li className="font-semibold">Send service-related communications</li>
          <li className="font-semibold">Send newsletters (if you've opted in)</li>
          <li className="font-semibold">Analyze usage patterns to improve content</li>
        </ul>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>3. Information Sharing</h2>
        <p className="font-semibold">
          We do not sell your personal information. We may share information with:
        </p>
        <ul style={{ color: "white", marginLeft: "20px" }}>
          <li className="font-semibold">Service providers (like Stripe for payment processing)</li>
          <li className="font-semibold">Analytics providers (like Google Analytics)</li>
          <li className="font-semibold">As required by law</li>
        </ul>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>4. Cookies and Tracking</h2>
        <p className="font-semibold">
          We use cookies and similar technologies to improve your experience, analyze usage, and deliver personalized content.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>5. Data Security</h2>
        <p className="font-semibold">
          We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>6. Your Rights</h2>
        <p className="font-semibold">
          You have the right to access, update, or delete your personal information. Contact us at support@vibe-stream.tv to exercise these rights.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>7. Children's Privacy</h2>
        <p className="font-semibold">
          Our service is not intended for children under 13. We do not knowingly collect information from children under 13.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>8. Changes to Privacy Policy</h2>
        <p className="font-semibold">
          We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page.
        </p>

        <h2 className="font-eagle-bold" style={{ fontSize: '24px', marginTop: '30px', marginBottom: '15px' }}>9. Contact Us</h2>
        <p className="font-semibold">
          If you have questions about this Privacy Policy, please contact us at support@vibe-stream.tv
        </p>

        <p className="font-semibold" style={{ marginTop: '40px', fontSize: '14px', color: '#999' }}>
          Last Updated: February 11, 2026
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
